import { render, staticRenderFns } from "./DocumentRequired.vue?vue&type=template&id=35314101&scoped=true"
import script from "./DocumentRequired.vue?vue&type=script&lang=js"
export * from "./DocumentRequired.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequired.vue?vue&type=style&index=0&id=35314101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35314101",
  null
  
)

export default component.exports